export const googleAnalyticsConfig = process.env.REACT_APP_GA_MEASUREMENT_ID;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const BASE_URL = process.env.REACT_APP_LIVE_BASE_URL;
